import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('user/paymentDetail', ['paymentDetails']),

    stateBsbNumber: {
      get () {
        return this.paymentDetails.bsb_number
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'bsb_number', value })
      }
    },

    stateAccountName: {
      get () {
        return this.paymentDetails.account_name
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'account_name', value })
      }
    },

    stateAccountNumber: {
      get () {
        return this.paymentDetails.account_number
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'account_number', value })
      }
    },

    stateAbn: {
      get () {
        return this.paymentDetails.abn
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'abn', value })
      }
    },

    stateSuperannuationNumber: {
      get () {
        return this.paymentDetails.superannuation_number
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'superannuation_number', value })
      }
    },

    stateSuperAnnuationFundABN: {
      get () {
        return this.paymentDetails.superannuation_number_abn
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'superannuation_number_abn', value })
      }
    },

    stateSoleTrader: {
      get () {
        return this.paymentDetails.sole_trader
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'sole_trader', value })
      }
    },

    stateStatementBySupplier: {
      get () {
        return this.paymentDetails.statement_by_supplier
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'statement_by_supplier', value })
      }
    },

    stateGstRegistered: {
      get () {
        return this.paymentDetails.gst_registered
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'gst_registered', value })
      }
    },

    stateAllowTalentChange: {
      get () {
        return this.paymentDetails.allow_talent_change
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'allow_talent_change', value })
      }
    },

    stateSwiftCode: {
      get () {
        return this.paymentDetails.swift_code
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'swift_code', value })
      }
    },

    stateIBANNumber: {
      get () {
        return this.paymentDetails.iban_number
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'iban_number', value })
      }
    },

    stateABARoutingNumber: {
      get () {
        return this.paymentDetails.aba_routing_number
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'aba_routing_number', value })
      }
    },

    stateMemberFund: {
      get () {
        return this.paymentDetails.member_fund
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'member_fund', value })
      }
    },

    stateMemberNumber: {
      get () {
        return this.paymentDetails.member_number
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'member_number', value })
      }
    },

    stateSpinNumber: {
      get () {
        return this.paymentDetails.spin_number
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'spin_number', value })
      }
    },

    stateSortCode: {
      get () {
        return this.paymentDetails.sort_code
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'sort_code', value })
      }
    },

    stateBankName: {
      get () {
        return this.paymentDetails.bank_name
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'bank_name', value })
      }
    },

    stateBankAddress: {
      get () {
        return this.paymentDetails.bank_address
      },

      set (value) {
        this.setPaymentDetailsProperty({ property: 'bank_address', value })
      }
    }
  },

  methods: {
    ...mapActions('user/paymentDetail', ['setPaymentDetailsProperty'])
  }
}
